<template>
  <div id="app">
    <router-view v-if="$store.state.isRouterAlive"/>
  </div>
</template>
<script>
export default {
  name: 'app',
  beforeMount(){
    let _this = this
    let lang = navigator.language||navigator.userLanguage;
    lang = lang.substr(0, 2);
    if (localStorage.getItem('lang') === null) {
      if (lang === 'zh') {
        _this.$store.state.lang = 1
        _this.$i18n.locale = 'zh'
        localStorage.lang = 1
      }else {
        _this.$store.state.lang = 0
        _this.$i18n.locale = 'en'
        localStorage.lang = 0
      }
    }else{
      _this.$store.state.lang = Number(localStorage.lang)
    }
    if (window.localStorage.getItem('token') !== null) {
      _this.$store.commit('setHistoryToStore')
    }
  },
  mounted () {
    this.selectLang()
  },
  methods: {
    selectLang(){
      if (localStorage.getItem('lang')==='1'){
        this.$i18n.locale = 'zh'
      } else{
        this.$i18n.locale = 'en'
      }
    },
    reload () {
      this.$store.state.isRouterAlive = false
      this.$nextTick(function () {
        this.$store.state.isRouterAlive = true
      })
    }
  }
}
</script>
<style >
#app{
  height: 100%;
}
.el-main{
  position:relative;
}
.ptbottomLink{
  width: 360px;
  position: absolute;
  bottom: 0;
  left: 50%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  font-size: 12px;
  padding:10px 0;
}
.ptbottomLink span{
  margin-right: 10px
}
.ptbottomLink a{
  color: rgba(103, 114, 229, 1);
} 
.ptbottomfont{
  font-size: 12px;
  margin-top:10px;
  text-align: center;
}
.ptbottomfont span{
  margin-right: 10px
}
.ptbottomfont a{
  color: rgba(103, 114, 229, 1);
}
/* .el-table .el-table__fixed{
  height:auto!important;
  bottom:17px;
}
.el-table .el-table__fixed-right {
  height:auto!important;
  bottom:17px;
}
.el-table__fixed-right::before, .el-table__fixed::before{
  height:0px!important;
} */
</style>
